
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ISearchCriteria, RequisitionSearchViewModel } from "@tylertech/tyler-api-types";

/**
 * RequisitionSearchService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class RequisitionSearchService {
    private readonly $apiService = inject(ApiService);
    
    SearchRequisitionsReadyForPurchaseOrder(pCriteria: ISearchCriteria<RequisitionSearchViewModel>): Promise<ISearchCriteria<RequisitionSearchViewModel>> {
        return this.$apiService.sendAuth("IRequisitionSearchService/SearchRequisitionsReadyForPurchaseOrder", pCriteria);
    }
}
